import React, { Component } from 'react'
//material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
//components
import PerfectScrollbar from "perfect-scrollbar";
//css
// import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const style = {
    center:{
        textAlign:'center'
    },
    formControl:{
        justifyContent:'center'
    }
}

let ps;
//内容暂时写死
class PlatformProtocol extends Component {
    constructor(props){
        super(props);
        this.state = {
            checked:false
        }
        // this.handleChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount(){
        ps = new PerfectScrollbar('#platformProtocolContainer', {
            suppressScrollX: true,
            suppressScrollY: false
          });      
    }
    componentWillUnmount(){
        ps.destroy();
    }
    handleChange(){
        this.setState({
            checked:!this.state.checked
        })
    }
    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <GridContainer>
                    <GridItem xs={1} sm={1} md={1}></GridItem>
                    <GridItem xs={10} sm={10} md={10}>
                        <div className="main-container" style={{width:'100%',position:'relative',overflow:'hidden'}} id="platformProtocolContainer">
                            <h2 className={classes.center}>认证协议</h2>
                            <p className="protocol-content">
                                您好！在您注册之前，请仔细阅读本用户服务协议。四川建造云是四川华西集采电子商务有限公司牵头搭建、多方共建的互联网招采供应链服务平台。本协议适用于四川建造云的用户（以下简称"用户"、"您"），若 您使用四川建造云（包括但不限于以任何形式接通、进入、浏览四川建造云，或者使用四川建造云的各项服务、功能等），您的使用行为将被视为对本用户协议全部内容的知晓、认可并同意遵守。
                            </p>
                            <p className="protocol-content">
                                一、接受<br/>
                                当您使用四川建造云时，您已经完全知晓、认可并同意遵守本协议中的条款。如果您拒绝接受本用户服务协议，您必须立即放弃使用四川建造云。四川建造云有权在必要时更新本协议。四川建造云保留对网站结构、服务、功能等进行调整的权利。除非特别声明以外，新功能、新服务均适用于本协议。无论本协议的每次更新还是服务内容调整，都会在四川建造云平台即刻发布，无需另行通知您并立即生效。
                            </p>
                            <p className="protocol-content">
                                二、用户<br/>
                                2.1依据中华人民共和国相关法律，凡具有民事权利能力和民事行为能力，依法独立享有民事权利和承担民事义务的企业、组织和个人，皆有资格申请成为四川建造云的用户。若您不具备此资格，请不要使用四川建造云。<br/>
                                2.2凡在四川建造云注册并通过四川建造云认证的企业、组织和个人即视为四川建造云的用户，并同意按本服务条例的规定享受权利、履行义务。<br/>
                                2.3为保证招投标活动的有序合规，使用四川建造云平台从事投标活动或与之相关工作的用户，均 须取得其所属企业、组织的合法授权，且提交的资料通过四川建造云核实，方可获取相应业务操作资格。申请认证的用户须向四川建造云提供包括但不限于《帐号申请表》（加盖 企业公章）、工商营业执照复印件（加盖企业公章）等资料。通过认证的用户执行年检制度，四川建造云有权要求每年用户提供相关材料。<br/>
                                2.4四川建造云有权禁止被取消用户资格的自然人、法人及其他组织再次使用四川建造云。<br/>
                            </p>
                            <p className="protocol-content">
                                三、用户责任<br/>
                                3.1用户在使用四川建造云时，须保证遵守国家的法律法规和规章制度，遵守四川建造云的有关协议、规定、规则、程序和惯例，不得利用四川建造云从事任何非法活动。<br/>
                                3.2用户自主负责对会员帐号、密码和权限的管理，并对其帐号发生的所有行为负责。如果因用户未妥善管理帐号、密码或者管理不善造成的信息泄露、利益受损或其他不合规行为，均由用户自己承担，四川建造云不承担任何责任。<br/>
                                3.3用户不得将帐号、密码及相关服务销售、转让、或赠与任何第三方，由此造成的一切后果和责任均由用户承担。如遇以上情形，四川建造云并有权单方面终止对用户提供的服务。<br/>
                                3.4用户确保通过四川建造云发布的所有信息（内容包括但不限于个人信息、商业信息，形式包括但不限于文字、图片、视频）的真实性、准确性、即时性、完整性和合法性，并独立承担所有责任。<br/>
                                3.5用户通过四川建造云平台与其他的用户发生所发生的任何业务和法律纠纷，均由用户方自行解 决，与四川建造云无关。倘若您与一名或一名以上用户发生争议，您同意免除四川建造云在因该等争议而引起的，或在任何方面与该等争议有关的不同 种类和性质的任何(实际和后果性的)权利主张、要求和损害赔偿等方面的责任。<br/>
                                3.6用户应遵守国家相关法律和规定，不得利用四川建造云平台从事任何有违法律和社会公 德的活动；不得传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的等信息；不得传输任何涉及国家安全的资料；不得侵犯 任何第三方著作权、专利、商标、商业秘密、隐私权、名誉权或其它权利的信息；不得干扰四川建造云的正常服务秩序。否则，四川建造云有权取消其帐号，有权单方面终止对 用户提供的服务。相关系统记录有可能作为证据提交司法机关。<br/>
                                3.7如因用户通过四川建造云平台使用的服务或线下的商务行为，致使任何单位、个人对四川华西集采电子商务有限公司及四川建造云关联企业提起的诉讼、仲裁或其他法律程序而产生的费用及遭受的损失，一切均由用户负责赔偿。<br/>
                            </p>
                            <p className="protocol-content">
                                四、信息收集<br/>
                                4.1您提供发布的企业信息、产品服务信息、报价、招投标信息将被显示在公共区域，对任何用户来说是公开的。请注意所有在这些场所公开的信息会成为公共信息，请您在决定公布前仔细考虑。<br/>
                                4.2当您在四川建造云注册成为会员时，四川建造云需要收集您的企业信息、供应和需求信息、产品和服务信息、价格信息、联系人信息等信息。同时，四川建造云会将相关信息汇聚到其数据库系统中，供其他用户授权访问。<br/>
                                4.3四川建造云有可能自动接收并记录您的浏览器和计算机上的信息，其中包括您的IP地址， cookie中的信息、软硬件特征信息、以及您需求的网页记录。<br/>
                                4.4四川建造云会对您及您的公司的身份和交易数据进行综合统计，并将相关数据进行分析和加工、再利用。<br/>
                                4.5您同意四川建造云以及四川建造云利用您的信息与您联络，并向您提供您感兴趣的信息，如：产品信息、招标信息。您接受本服务协议即为同意接收这些资料。<br/>
                                4.6您授予四川建造云无偿使用用户提交的“信息资料”的权利，即四川建造云购有权（全 部或部分地）使用、复制、修订、改写、发布、翻译、分发、执行和 展示"信息资料"或制作其派生作品，以任何形式、媒体或技术将"信息资料"纳入其他作品内。同时，您同意四川建造云在未改变您提供信息的实质内容的情况下免于承 担因该信息引起的任何法律责任。<br/>
                            </p>
                            <p className="protocol-content">
                                五、责任声明<br/>
                                5.1在不影响用户发布信息的真实性的情况下，四川建造云有权对于用户发布的信息进行策划宣传、 向第三方网站推广、链接、编辑等处理。对于用户通过四川建造云平台发布的任何虚假的、非法的、中伤他人的、欺骗性的或侵犯他人合法权益的信息资料，四川建造云将保留 不通知用户即予以删除的权利，并可以单方面解除合同。<br/>
                                5.2四川建造云上的其数据信息均由用户方自主提供，四川建造云仅作客观数据呈现，用户须自主判断 其数据的真实性、有效性。四川建造云不对四川建造云平台上任何一个用户提供信誉保障和责任担保。四川建造云不承诺商贸信息的真实性或准确性，不控制交易所涉及的产品或服务 的质量、安全或合法性，不具备管理交易方履行其在贸易协议项下的各项义务的能力。<br/>
                                5.3四川建造云将尽最大努力来减少错误，但网站上提供的服务和信息仍可能包含错误内容，四川建造云对用户因使用四川建造云而造成的损失不负法律责任。四川建造云对其服务和信息不 作保证，不论什么情况下对用户因使用四川建造云而造成的直接、间接、偶尔的、特殊的、惩罚性的损害或其他一切损害不负法律责任。若您对四川建造云提供的部分或所有 服务不满，您唯一的补救措施是停止使用这些服务。<br/>
                                5.4四川建造云仅作为四川建造云平台的提供商，不参与用户的采购和销售的相关业务，不影响用户自行 选择交易方、投标报价或评标定标等决策判断。用户使用四川建造云平台直接或间接所产生的各项收益无需与四川建造云分享，同样四川建造云对用户使用四川建造云平台直接或间接所产 生的各类损失也不承担任何责任。<br/>
                                5.5四川建造云不保证四川建造云是不受干扰的、没有故障的。四川建造云不对因人为或非人为因素造成的用户 与四川建造云服务器之间的连接受阻而无法访问负责。您同意独立承担因操作者原因、第三方软件故障、硬件故障、网络故障、病毒、黑客、政策调整、四川建造云平台更 新、服务器配置等各种原因导致的服务中断、操作或传输的迟延、未经授权的进入等引起的损失。<br/>
                                5.6由于地震、台风、水灾、火灾、战争、法律法规、意外事故以及其他不可抗力事件，致使四川建造云相关服务履行迟延或不能履行的，四川建造云不承担任何责任。<br/>
                                5.7四川建造云含有与其他网站的链接。四川建造云并不能控制这些网站及其所提供的资源，所以对链接网站上的内容、广告、服务、产品信息的真实、准确、即时、完整性不做任何承诺，并且对链接网站不承担任何法律责任。<br/>
                                5.8任何四川建造云的通知都将以电子邮件形式，向您的电子邮箱地址发送（您同意，如您修改原注册时提交的电子邮箱地址、并通过四川建造云审核的，以新电子邮箱地址为准）。该电子邮件进入前述电子邮箱接收系统时，视为送达。<br/>
                                5.9四川建造云认为申请注册的用户与四川建造云形成竞争或对四川建造云正常运营造成损害时，可拒绝其申请和注册。<br/>
                                5.10任何因用户违反本协议而造成四川建造云的经济或名誉损失，四川建造云有权追究其经济责任与法律责任。即使四川建造云未就您的某项违约行为立刻采取行动，并不表明四川建造云放弃就任何继后或类似的违约事件采取行动的权利。<br/>
                                5.11四川建造云转让本协议无需经您的同意。<br/>
                            </p>
                            <p className="protocol-content">
                                六、知识产权<br/>
                                6.1四川建造云对其开发四川建造云平台享有的知识产权，受法律保护。<br/>
                                6.2除非有合同书面约定，四川建造云未向用户授予与任何软件著作权、专利权、商标专用权、商业秘密及其他权利有关的任何权利。<br/>
                                6.3四川建造云平台上所有内容的选材、整理、编排、排版、汇编，以及由四川建造云创作的文字、图片 等作品的著作权，无论是否明示，均属四川建造云所有。任何自然人、法人 及其他组织未经四川建造云书面授权或许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的四川建造云上的内容， 包括但不限于公司信息、产品信息，四川建造云将保留追究其法律责任的权利。<br/>
                                6.4所有其它在四川建造云上出现的商标为它们各自的权利人所有。<br/>
                                6.5未经四川建造云书面授权，用户出现以下任何一种行为，均视为对于四川建造云的侵权：<br/>
                                • 将四川建造云及其信息向任何第三方提供、销售、出租、出借、转让或披露、让其接触、修改或分许可、转许可、通过信息网络传播或以其他形式供他人利用。<br/>
                                • 对四川建造云及其信息进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从软件导出程序源代码的行为，或在软件的基础上书写或开发衍生软件、衍生产品或其他软件。<br/>
                                • 限制、破坏或绕过四川建造云的加密措施。<br/>
                                • 去除、掩盖或更改四川建造云上有关软件著作权或商标的标志。<br/>
                                • 将四川建造云及其信息用于除甲方内部使用以外的任何第三方，包括但不限于向第三方提供数据处理服务、应用服务、商业共享或其他软件共享安排。<br/>
                            </p>
                            <p className="protocol-content">
                                七、费用<br/>
                                7.1注册免费会员及使用对应的免费会员服务是免费的；注册标准会员或选择其他收费服务，需要支付相应费用，具体费用标准请参看四川建造云上公布的相应说明。<br/>
                                7.2若您未及时支付相应费用，四川建造云有权在任何时刻对于您所享受的会员权益进行调整，而无需征得您的同意。<br/>
                                7.3四川建造云保留调整价格以及修改费用条款的权利，一旦调整或修改，将立即在四川建造云上公布。<br/>
                                7.4四川建造云不承担您因使用四川建造云的服务而需支付的软硬件、税收及其它费用。<br/>
                                7.5四川建造云有权在未经通知的情况下随时改变或不继续提供某些或全部用户服务权益。<br/>
                            </p>
                            <p className="protocol-content">
                                八、中止与终止<br/>
                                8.1对于用户的以下行为，四川建造云有权在未告知的情况下中止或终止其相关服务或者拒绝其以任何形式使用四川建造云，且不对因此给您造成的服务减少等承担任何责任，并保留追究您法律责任的权利：<br/>
                                • 用户所提供的信息存在虚假信息，包括但不应限于营业执照、企业或产品信息、资质信息、个人信息等。<br/>
                                • 用户所提供的营业执照系冒用，或证照信息与实际经营状况不一致时，或用户未取得其服务的企业、组织合法授权。<br/>
                                • 利用四川建造云滥发重复信息，发布国家法律法规等禁止或限制发布的信息，发布不属于会员经营范围的信息，或与四川建造云服务无关的信息；<br/>
                                • 冒用其他企业的名义发布商业信息，进行商业活动；<br/>
                                • 计划破坏、攻击四川建造云网站系统、网络的完整性，或者试图擅自进入四川建造云网站电脑系统、网络；<br/>
                                • 使用或提供含有毁坏、干扰、截取或侵占任何系统、数据或个人资料的任何电脑病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他破坏性程序；<br/>
                                • 盗用他人在四川建造云上的登录名和/或密码；未经四川建造云同意的帐号出售或授权使用行为；通过或从事涉及四川建造云的欺诈活动；通过或从事涉及四川建造云的知识产权侵权行为；<br/>
                                • 如发现用户利用四川建造云及四川建造云所提供的服务和信息用于商业用途并与四川建造云形成竞争或损害四川建造云利益的，四川建造云有权单方终止其用户资格。<br/>
                                • 违反国家法律法规、规章制度、四川建造云有关协议、规定、规则、程序和惯例的其他行为。<br/>
                                8.2如您连续二年未使用您的帐号登录过本网站，您的帐号可能被注销，所有服务将同时终止。<br/>
                                8.3您同意，在四川建造云未向您收费的情况下，四川建造云可自行全权决定以任何理由(包括但不限于四川建造云认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事)终止您的帐户、密码以及相关服务。<br/>
                                8.4您同意，在四川建造云向您收费的情况下，四川建造云应基于合理的怀疑且经电子邮件通知的情况下实施终止服务的行为。<br/>
                                8.5您进一步承认和同意，四川建造云根据本协议规定终止您服务的情况下可立即使您的帐户无效， 或注销您的帐户以及在您的帐户内的所有相关资料和档案，和/或禁止您进一步接入该等档案或使用相关服务。帐户终止后，四川建造云没有义务为您保留原帐户中或与之 相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，四川建造云不会就终止向您提供服务而对您或任何第三者承担任何责任。<br/>
                            </p>
                            <p className="protocol-content">
                                九、适用法律与其他<br/>
                                9.1本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。如与本协议有关的某一特定事项缺乏明确法律规定，则应参照通用的国际商业惯例和行业惯例。<br/>
                                9.2如因本协议内容或其执行发生争议，双方应友好协商解决；协商不成时，任何一方均可向四川建造云所在地的人民法院提起诉讼。<br/>
                                9.3如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br/>
                                9.4本协议以取代此前您和四川建造云就相同事项订立的所有口头、书面、及其他通信方式中的表述或协议。任何不在本协议或附件书面约定的条款范围内的口头承诺对您和四川建造云双方均不具备约束力。<br/>
                            </p>
                        </div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={1}></GridItem>
                </GridContainer>
                <FormGroup row className={classes.formControl}>
                    <FormControlLabel label="我已阅读并同意以上协议"
                        control={<Checkbox color="primary" checked={this.props.formObj} onChange={this.props.changeFun} value="checked"/>} />
                </FormGroup>
            </React.Fragment>
            
        )
    }
}

export default withStyles(style)(PlatformProtocol);